<template>
	<div class="modSelection">
		<h1 class="modSelectionTitle allCaps">Gear modifications</h1>
		<div v-for="(tier, tierId) in availableMods" :key="tierId" class="tierContainer">
			<h2 v-if="selectedClassId !== 'R'">Tier {{ tierId + 1 }}<p v-if="tierId > 0" class="levelIndicator">Level
				{{tierId * 4}}</p></h2>
			<h2 v-if="selectedClassId === 'R'">Tier {{ tierId + 1 }}<p v-if="tierId > 0" class="levelIndicator">Rank
				{{tierId + 1}}</p></h2>
			<div class="tierSubContainer"
			     :class="[tier.length === 1 ? '' : tier.length === 2 ? 'tierBackgroundGradientHalf' : 'tierBackgroundGradient']">
				<div v-for="(mod, modId) in tier"
				     :key="modId"
				     v-on:click="selectMod(selectedClassId, selectedEquipmentId, tierId, modId, mod.selected)"
				     v-on:mouseover="hoverMod(selectedClassId, selectedEquipmentId, tierId, modId)"
				     class="tooltip-target modDisplay"
				     :class="[mod.selected ? 'selectedTemp' : '']">
					<svg viewBox="0 0 80 50"
					     height="100%"
					     class="mod"
					     :class="[mod.selected ? 'modBackgroundActive' : 'modBackground']">
						<path
								d="M 0.3679663,25 13.7826,0.609756 H 66.221625 L 79.636259,25 66.221625,49.390244 H 13.7826 L 0.3679663,25"/>
						<g>
							<svg xmlns="http://www.w3.org/2000/svg"
							     y="10%"
							     viewBox="0 0 80 50"
							     :class="[mod.selected ? 'modIconActive' : 'modIcon']"
							     height="80%"
							     preserveAspectRatio="xMidYMid meet"
							     v-html="getIconFromPath(mod.icon)"></svg>
						</g>
					</svg>
				</div>
				<div v-if="tier.length === 2" class="pseudoModDisplay"></div>
			</div>
		</div>
		<div class="overclockContainer" :class="getOverclocksAvailable(computedState)">
			<h2>Overclock</h2>
			<div class="overclockDisplay">
				<!--todo: show name of selected overclock on hover?-->
				<svg v-popover:overclocks.top
				     viewBox="0 0 80 80"
				     height="100%"
				     class="mod overclockBackground hundredPercent">
					<g :display="getCleanDisplay(computedState)">
						<g> <!-- background layer -->
							<path
									style="fill:#379c5d;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"
									d="M 16.645549,6.8857899 63.523153,6.92059 79.999998,30.39618 52.538582,73.114198 26.69254,73.0896 2.5e-7,30.232339 Z"
									id="path817"/>
						</g>
						<g transform="translate(0,-217)">
							<path style="fill:#000000;stroke-width:0.32307553"
							      d="M 14.900282,271.17622 3.1080334,252.26279 1.5540136,249.74756 2.5e-7,247.23234 8.3227717,235.55906 l 8.3227773,-11.67327 23.438794,0.0174 23.438811,0.0174 8.238423,11.6389 L 80,247.19838 v 0.0989 0.0989 l -13.730705,21.35901 -13.730713,21.35901 -12.923021,-0.0123 -12.92302,-0.0123 z m 40.513633,11.25399 3.844557,-6.04021 -1.016278,-1.83457 -1.016287,-1.83457 3.937786,-6.63632 3.937787,-6.6363 2.57636,-0.0928 2.57636,-0.0928 3.822907,-5.9508 3.822909,-5.95081 v -0.24646 -0.24647 l -7.533474,-10.60265 -7.533473,-10.60266 -6.15636,-0.0876 -6.156359,-0.0876 -1.347607,2.26837 -1.347615,2.26836 h -7.69994 -7.699939 l -1.255394,-2.18076 -1.255403,-2.18076 -6.189658,-0.0877 -6.189668,-0.0876 -7.6350455,10.71246 -7.6350361,10.71247 0.1854321,0.48323 0.1854322,0.48323 3.6035723,5.77266 3.6035723,5.77266 2.6093837,0.013 2.609385,0.013 3.715374,6.33241 3.715364,6.33242 0.128735,0.34077 0.128734,0.34076 -1.060593,1.96527 -1.060593,1.9653 3.677999,5.88452 3.678009,5.88452 11.792249,-0.0128 11.792258,-0.0128 3.844558,-6.0402 z m -30.453253,-0.32014 -3.347257,-5.40143 1.08499,-2.01551 1.084991,-2.0155 -0.339123,-0.56909 -0.339122,-0.56909 -3.85954,-6.54229 -3.859539,-6.54228 h -2.591517 -2.591516 l -3.3691817,-5.41152 -3.3691721,-5.41151 -0.00183,-0.48462 -0.00183,-0.48461 7.2025468,-10.0961 7.202557,-10.09611 h 5.778086 5.778095 l 1.207809,2.09998 1.207809,2.09999 h 8.322916 8.322915 l 1.207809,-2.09999 1.207809,-2.09998 h 5.730281 5.730273 l 6.367763,8.96535 6.367765,8.96534 0.964653,1.36218 0.964654,1.36218 -3.579725,5.58394 -3.579725,5.58394 -2.578649,0.0934 -2.57864,0.0934 -4.214726,7.10173 -4.214726,7.10174 1.002092,1.85099 1.002092,1.85097 -3.550592,5.49229 -3.550585,5.49228 -11.436788,0.0707 -11.436788,0.0707 z m 28.198477,-0.0313 2.70689,-4.16064 0.402047,-0.75124 0.402057,-0.75123 -1.096548,-2.03382 -1.096548,-2.03382 -0.161539,0.0143 -0.161538,0.0143 -2.90768,4.65716 -2.90768,4.65716 -8.29643,0.0127 -8.29643,0.0127 -2.997356,-4.6846 -2.997355,-4.68459 H 25.564205 25.37739 l -1.035904,2.10069 -1.035903,2.1007 2.98578,4.83323 2.985789,4.83326 10.587544,0.0122 10.587545,0.0122 z m -36.943038,-25.84143 -0.32229,-0.60221 -2.374636,-3.84006 -2.374635,-3.84008 -0.21309,-0.35839 -0.21308,-0.35838 5.249017,-7.39544 5.249026,-7.39542 4.569719,-0.16154 4.569728,-0.16155 0.222467,-0.22336 0.222458,-0.22337 -1.1942,-1.96585 -1.1942,-1.96588 -4.702474,0.0893 -4.702465,0.0892 -5.936823,8.39996 -5.9368314,8.39996 -0.840379,1.20445 -0.840379,1.20445 3.0241336,4.85322 3.0241338,4.85322 h 2.518545 2.518554 z m 55.709708,-4.24808 3.138728,-4.8503 -0.3088,-0.39967 -0.308791,-0.39969 -6.542801,-9.29688 -6.542802,-9.29688 -4.712145,0.0892 -4.712145,0.0892 -1.059733,1.7769 -1.059723,1.77692 -0.01255,0.40384 -0.01255,0.40386 h 4.670686 4.670687 l 5.236964,7.33508 5.236965,7.33508 -0.0109,0.33796 -0.0109,0.33796 -2.789138,4.3557 -2.789147,4.35568 v 0.24815 0.24813 h 2.389664 2.389655 l 3.138728,-4.85031 z m -51.381551,22.44558 0.859245,-1.46619 -0.101618,-0.57766 -0.101627,-0.57768 -3.392296,-5.7018 -3.392287,-5.7018 -2.375103,-0.008 -2.3751025,-0.008 0.7597245,1.25046 0.759724,1.25046 4.038442,6.49148 4.038442,6.49148 0.211615,0.0119 0.211606,0.0119 0.859235,-1.46619 z m 44.909678,-6.20734 4.692263,-7.51197 v -0.17522 -0.17523 l -2.333287,0.0949 -2.333297,0.0949 -3.53202,5.95933 -3.53203,5.95931 0.903368,1.72541 0.903369,1.72542 0.269685,-0.0925 0.269687,-0.0925 z m -17.263046,-41.3532 0.968473,-1.69615 h -8.891118 -8.891108 v 0.16136 0.16137 l 0.888459,1.61573 0.888459,1.6157 7.034177,-0.081 7.034194,-0.081 z"
							      id="path838"/>
						</g>
					</g>
					<g :display="getBalancedDisplay(computedState)">
						<g>
							<path
									style="fill:#e9ca37;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"
									d="M 0.676502,26.11698 5.2900339,23.37613 V 19.90961 L 39.830893,0 74.387947,19.8847 v 3.47593 l 4.935551,2.80812 V 53.989009 L 74.419528,56.68047 74.223427,60.412899 40.283264,79.999998 5.4545499,60.39224 5.125512,56.603608 0.84802198,54.13516 Z"
							/>
						</g>
						<g transform="translate(0,-217)">
							<path style="fill:#000000;stroke-width:0.32903767"
							      d="m 22.39999,287.18321 -16.94544,-9.79097 -0.164519,-1.89431 -0.164519,-1.89432 -2.138745,-1.23423 -2.138745,-1.23422 -0.08576,-14.00909 -0.08576,-14.00909 2.306765,-1.37043 2.306767,-1.37042 v -1.73327 -1.73325 L 22.560466,226.9548 39.830893,217 l 0.250823,0.13716 0.250832,0.13716 17.0277,9.80518 17.0277,9.8052 v 1.73796 1.73797 l 2.46778,1.40405 2.46777,1.40407 v 13.91014 13.91012 l -2.45198,1.34573 -2.45199,1.34573 -0.0981,1.86622 -0.098,1.86621 -7.07431,4.07885 -7.07432,4.07886 -9.895762,5.7147 -9.895772,5.71469 -0.468917,-0.0129 -0.468919,-0.0129 z m 35.124778,-2.01028 15.54703,-8.99489 v -2.44763 -2.44764 l 0.97011,0.21308 0.97013,0.21308 1.0041,-0.74237 1.00411,-0.74237 v -13.04966 -13.04965 l -1.27722,-0.57595 -1.27721,-0.57594 -0.69701,0.37303 -0.69701,0.37303 -0.0156,-2.89066 -0.0156,-2.89065 -15.95838,-9.21306 -15.958379,-9.21305 -0.627196,-0.29025 -0.62721,-0.29025 -16.459727,9.5033 -16.459739,9.50331 -0.0075,2.71455 -0.0075,2.71457 -0.246779,-0.0231 -0.246778,-0.0231 -0.658075,-0.26783 -0.658075,-0.26782 -1.233892,0.68057 -1.23389,0.68059 v 13.10623 13.10624 l 1.164736,0.55543 1.164736,0.55542 0.961682,-0.36299 0.961684,-0.36299 0.09458,2.78453 0.09459,2.78455 16.432691,9.51642 16.432689,9.51643 1.006315,-0.58878 1.006305,-0.58877 15.547032,-8.9949 z m -33.658043,-0.1579 -16.108912,-9.32809 -0.09439,-2.59703 -0.0944,-2.59705 3.220254,-1.32396 3.220249,-1.32396 0.08674,-10.7064 0.08665,-10.7064 -1.238316,-0.53506 -1.238323,-0.53506 -1.974227,-0.77012 -1.974226,-0.77011 -0.08889,-2.61299 -0.08889,-2.61299 9.960016,-5.74311 9.960014,-5.74312 6.170171,-3.58713 6.170152,-3.58713 0.410588,0.16544 0.410594,0.16544 15.629289,9.06129 15.62929,9.06129 0.0945,2.77654 0.0945,2.77655 -3.30701,1.41208 -3.30701,1.41209 0.0867,10.70119 0.0867,10.70118 3.2081,1.29127 3.20812,1.29127 -0.005,2.51306 -0.005,2.51306 -14.51964,8.39046 -14.519642,8.39046 -1.530447,0.89256 -1.53045,0.89257 z m 20.578789,4.63388 4.11297,-2.39803 0.09752,-2.01803 0.09751,-2.01803 4.956504,-2.80667 4.95651,-2.80669 1.39112,0.81526 1.39113,0.81525 h 0.42182 0.42181 l 3.90902,-2.31318 3.90903,-2.31316 v -1.63087 -1.63087 l -1.2147,-0.50753 -1.21468,-0.50753 -0.75954,-0.19064 -0.75954,-0.19062 -0.01,0.94052 -0.01,0.94053 -11.42425,6.49409 -11.424236,6.49409 -1.684001,0.97336 -1.684,0.97335 -13.122721,-7.46938 -13.122687,-7.46937 -0.10311,-1.06745 -0.103102,-1.06744 h -0.103503 -0.103913 l -1.86557,0.85409 -1.865572,0.85409 0.09836,1.64739 0.09836,1.6474 3.908917,2.26956 3.90892,2.26957 0.368568,-0.004 0.368577,-0.004 1.416416,-0.80979 1.416415,-0.80977 4.835302,2.74065 4.835294,2.74067 0.16452,1.99938 0.164519,1.9994 1.156694,0.76248 1.156704,0.76247 1.475605,0.7995 1.475596,0.79949 1.480669,0.9217 1.48067,0.92171 0.493559,-0.003 0.493559,-0.003 4.112969,-2.39803 z m -14.007918,-5.0167 -0.213179,-1.28727 -4.581039,-2.57024 -4.581036,-2.57024 -1.167868,0.72178 -1.167878,0.7218 0.438288,0.41821 0.438287,0.41822 5.251737,2.98957 5.251746,2.98957 0.272061,-0.27206 0.272061,-0.27207 z m 25.035812,-1.50093 5.83518,-3.3395 -1.27497,-0.77178 -1.27497,-0.77178 -0.16452,0.0187 -0.16452,0.0188 -4.44201,2.5503 -4.442004,2.5503 -0.100284,1.54221 -0.100285,1.54222 h 0.146603 0.146602 z M 13.515974,242.49085 c 0,0 17.948486,-9.49795 26.534363,-14.94305 l 26.111661,14.86916 v 1.00371 1.00371 l 0.57581,-0.23453 0.57582,-0.23453 1.39841,-0.48968 1.39842,-0.48968 v -1.70291 -1.70292 l -4.18776,-2.43342 -4.18775,-2.43342 -1.54889,0.86478 -1.54888,0.86478 -4.95709,-2.82491 -4.957084,-2.82491 v -1.8616 -1.86162 l -4.439288,-2.56876 -4.439277,-2.56876 -4.42574,2.5786 -4.425744,2.5786 -0.101252,1.94357 -0.101256,1.94357 -1.536705,0.85325 -1.536716,0.85325 -3.325384,1.89055 -3.325374,1.89054 -1.331641,-0.84062 c -0.554732,-0.33615 -0.985435,-0.72748 -1.596506,-0.94968 -2.883479,1.77657 -6.038739,3.46689 -8.563331,4.919 -0.0024,1.09831 -0.0049,2.19663 -0.0073,3.29494 1.314898,0.42789 2.703866,1.2935 3.948449,1.47617 1.1e-5,-0.62106 1e-5,-1.24212 1e-5,-1.86318 z m 12.063943,-9.19615 4.436609,-2.50428 0.162103,-0.42245 0.162114,-0.42245 -0.104183,-1.17525 -0.104182,-1.17525 -5.53,3.24767 -5.529991,3.24767 -0.0084,0.23765 -0.0084,0.23765 0.932015,0.6145 0.932024,0.61449 0.11199,0.002 0.11199,0.002 z m 34.233361,1.80449 1.13229,-0.6998 -0.27086,-0.26201 -0.27087,-0.26203 -4.84083,-2.80386 -4.840844,-2.80387 -0.689455,-0.36899 -0.689456,-0.36898 0.101171,1.54299 0.10117,1.54299 4.442004,2.57514 4.44201,2.57514 0.12569,0.0165 0.12568,0.0165 1.1323,-0.69979 z m 10.7037,33.7164 -3.70644,-1.50118 0.087,-9.91729 0.087,-9.91729 3.90041,-1.58296 3.9004,-1.58297 0.62386,0.56459 0.62387,0.56459 v 11.94022 11.94021 l -0.7313,0.51223 -0.73128,0.51221 -0.17357,-0.0156 -0.17356,-0.0156 -3.70645,-1.50118 z m 4.2,-11.43721 V 246.054 l -0.40825,-0.13609 -0.40825,-0.13608 -2.96439,1.20138 -2.96438,1.20138 v 9.14069 9.14069 l 2.6323,1.0891 2.6323,1.0891 0.74033,0.0293 0.74034,0.0293 v -11.32438 z m -70.520319,12.22924 -0.561075,-0.41131 0.08689,-12.16655 0.08689,-12.16655 0.846659,-0.29767 0.846661,-0.29767 1.127566,0.49793 1.127566,0.49793 2.545943,0.94353 2.545953,0.94353 0.0037,9.91641 0.0037,9.9164 -2.714563,1.05143 -2.714561,1.05143 -0.873362,0.46622 -0.873361,0.46623 H 5.219106 4.756947 Z m 4.630526,-2.20608 2.714561,-1.04988 -0.0032,-9.27139 -0.0032,-9.2714 -2.953685,-1.1063 -2.953685,-1.1063 -0.498047,0.19112 -0.498047,0.19112 v 10.96728 10.96728 l 0.402037,0.40204 0.402036,0.40203 0.338299,-0.13285 0.338299,-0.13286 z"
							/>
						</g>
					</g>
					<g :display="getUnstableDisplay(computedState)">
						<g>
							<path
									style="fill:#d13500;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"
									d="M 8.4999998e-5,40.126319 8.4302848,33.505759 V 13.11006 l 4.6897602,-4.6584702 20.295218,-0.006 6.685852,-8.4074599 6.696559,8.41266 h 20.13055 l 4.689771,4.6584701 v 20.151169 l 8.381918,7.054062 -8.37692,6.661528 -0.006,20.327659 -4.368421,4.334931 H 46.596244 L 39.857415,79.961869 33.539996,71.9618 H 13.120045 L 8.4302848,67.303329 v -20.47685 z"
							/>
						</g>
						<g transform="translate(0,-217)">
							<path style="fill:#000000;stroke-width:0.32238683"
							      d="m 36.699255,292.96222 -3.15926,-4.00042 h -10.20998 -10.20997 l -2.34488,-2.32924 -2.34488,-2.32923 V 274.0649 263.82648 l -3.94923,-3.1136 -3.94925,-3.1136 -0.26586,-0.23648 -0.26586,-0.23648 4.2151,-3.31028 4.2151,-3.31028 V 240.3079 230.11006 l 2.34488,-2.32924 2.34488,-2.32923 10.14761,-0.003 10.14761,-0.003 3.34292,-4.20373 3.34293,-4.20373 0.0812,0.0959 0.0812,0.0959 3.26708,4.11044 3.26708,4.11042 h 10.06527 10.06528 l 2.34488,2.32924 2.34489,2.32923 v 10.07559 10.07558 l 4.17345,3.31154 4.17347,3.31154 0.0175,0.21549 0.0175,0.21549 -4.18846,3.33077 -4.18846,3.33076 -0.003,10.16383 -0.003,10.16383 -2.18422,2.16747 -2.1842,2.16746 h -10.32616 -10.32617 l -3.18093,4.04514 -3.18094,4.04514 -0.18848,0.11649 -0.18848,0.11649 -3.15926,-4.00044 z m 6.2672,-2.04947 2.6995,-3.52963 10.30771,-0.0166 10.3077,-0.0166 2.02359,-2.0056 2.02359,-2.0056 0.0166,-10.3257 0.0166,-10.32569 3.52963,-2.69951 3.52961,-2.69949 -0.01,-0.20198 -0.0101,-0.20197 -3.53623,-2.69568 -3.53621,-2.69568 v -10.19111 -10.19112 l -2.0056,-2.0236 -2.00561,-2.02359 h -10.22048 -10.22055 l -2.6507,-3.46565 -2.65071,-3.46566 -0.23472,-0.26566 -0.23473,-0.26566 -2.86149,3.71997 -2.86149,3.71996 -10.15518,0.0175 -10.1552,0.0174 -2.01491,1.95925 -2.01492,1.95925 -0.0113,10.20476 -0.0113,10.20475 -3.71996,2.8615 -3.71998,2.86149 0.26568,0.23054 0.26564,0.23055 3.46567,2.67712 3.46565,2.67712 v 10.36862 10.36861 l 1.89737,1.83529 1.89737,1.8353 h 10.31735 10.31733 l 2.69568,3.53622 2.69568,3.53622 0.20197,0.01 0.20198,0.0101 2.69951,-3.52963 z m -6.59649,-2.69727 -3.49303,-4.57307 3.75301,-0.091 3.753,-0.091 3.48976,0.091 3.48974,0.091 -3.50141,4.51124 -3.5014,4.51124 -0.24832,0.0619 -0.24832,0.0619 z m 6.48009,-0.42853 2.29309,-2.94797 -0.19531,-0.1953 -0.19531,-0.1953 h -4.78206 -4.78208 l 9.1e-4,0.24179 9.2e-4,0.24179 2.44972,3.17487 2.44975,3.17485 0.2335,-0.27337 0.2335,-0.27339 2.29309,-2.94797 z m -30.32426,-2.94982 -1.84846,-1.86795 0.0855,-9.7238 0.0854,-9.7238 1.69821,1.32342 1.69822,1.32342 0.1607,-0.16069 0.16069,-0.16069 -0.0858,-8.95521 -0.0858,-8.95521 -1.68305,1.33057 -1.68305,1.33057 h -0.17068 -0.17067 v -9.60202 -9.60202 l 1.70266,-1.68151 1.70268,-1.68152 h 9.76364 9.76366 l -1.09995,1.37014 -1.09995,1.37015 -0.2302,0.40298 -0.23022,0.40298 h 9.23318 9.23316 l -1.47074,-1.85372 -1.47073,-1.85372 9.57675,-0.0855 9.57676,-0.0855 1.86675,1.86677 1.86677,1.86677 -0.0855,9.56946 -0.0855,9.56947 -1.71469,-1.30772 -1.71469,-1.3077 -0.14413,0.14414 -0.14414,0.14413 0.0857,9.1063 0.0857,9.1063 1.65809,-1.32039 1.65807,-1.32038 h 0.19564 0.19565 v 9.6011 9.60109 l -1.86802,1.84854 -1.86803,1.84853 -9.60935,-0.0854 -9.60934,-0.0855 1.50239,-1.93432 1.50241,-1.93432 -9.09448,-0.0857 -9.09448,-0.0857 -0.14657,0.14658 -0.14659,0.14658 1.5036,1.95404 1.50359,1.95403 h -9.78113 -9.78114 z m 13.55595,0.17543 -0.48086,-0.72537 -3.58832,-0.0912 -3.5883,-0.0911 v 0.22697 0.22696 l 0.53355,0.58957 0.53354,0.58956 h 3.53562 3.53562 z m 35.41597,0.16119 0.42827,-0.56417 0.0102,-0.2418 0.0102,-0.24179 h -3.43013 -3.4301 l -0.42828,0.56418 -0.42827,0.56417 -0.0102,0.24179 -0.0102,0.2418 h 3.43013 3.43011 z m -43.58667,-0.56417 -0.52809,-0.80598 h 4.22067 4.22068 l 0.52809,0.80598 0.52808,0.80596 h 1.89725 1.89724 l -0.003,-0.24179 -0.003,-0.24179 -1.47446,-1.85373 -1.47449,-1.85372 h -4.71376 -4.71374 l -1.0631,-1.0304 -1.06311,-1.0304 -0.018,-4.85316 -0.018,-4.85316 -1.73633,-1.37015 -1.73632,-1.37013 h -0.18 -0.18 v 7.5976 7.59761 l 1.51222,1.75161 1.51223,1.75161 h 1.55788 1.55788 z m 36.13697,-0.1612 0.58352,-0.64478 h 4.20553 4.20554 l -0.38685,0.38687 -0.38687,0.38687 v 0.2579 0.25791 h 1.35907 1.35907 l 1.54241,-1.51922 1.54241,-1.51921 v -7.66881 -7.6688 h -0.18842 -0.18843 l -1.90709,1.49829 -1.90709,1.4983 v 4.6923 4.69231 l -1.03041,1.0631 -1.0304,1.0631 h -4.73373 -4.73372 l -1.22486,1.53134 -1.22487,1.53134 -0.30418,0.40298 -0.30418,0.40298 h 2.08502 2.08502 z m -37.88046,-44.44693 v -4.68988 l 1.19379,-1.22254 1.19378,-1.22254 h 4.73117 4.73118 l 1.32875,-1.72231 1.32874,-1.72231 v -0.21201 -0.21201 h -1.91092 -1.91092 l -0.63398,0.80596 -0.63397,0.80597 h -4.28971 -4.2897 l -0.32744,0.0221 1.04643,-0.74114 3.87591,0.0535 3.87592,0.0535 0.34249,-0.63993 0.34248,-0.63993 v -0.1824 -0.18239 h -3.28369 -3.28369 l -0.74615,0.70097 -0.74614,0.70097 -1.42356,0.87693 1.42356,-1.63409 h -1.35907 -1.35908 l -1.54241,1.51922 -1.5424,1.51921 v 7.82967 7.82966 l 1.93431,-1.50214 1.93432,-1.50213 z m 50.37883,-9.24262 -1.53722,-1.75285 -1.5813,-0.004 -1.5813,-0.004 0.53354,0.58956 0.53354,0.58957 v 0.2164 0.21641 h -4.09831 -4.09833 l -0.65689,-0.82355 -0.65687,-0.82355 -2.01055,0.0982 -2.01057,0.0982 1.4725,1.85373 1.4725,1.85372 h 4.71374 4.71375 l 1.0631,1.0304 1.0631,1.03041 v 4.7608 4.76081 l 2.01492,1.6771 2.01491,1.67711 0.0864,-7.64572 0.0865,-7.64572 z m -5.08348,-1.43859 -0.5835,-0.64478 h -3.49902 -3.49902 l 0.40266,0.64478 0.40267,0.64476 h 3.67986 3.67988 z m 4.997,27.8972 v -7.29648 l 0.43893,0.2578 0.43891,0.25781 4.21663,3.22387 4.21661,3.22387 0.019,0.19005 0.019,0.19007 -2.01492,1.55633 -2.01492,1.55633 -2.65969,2.06841 -2.65968,2.06842 v -7.29648 z m 7.52709,0.12734 0.27338,-0.23351 -3.17487,-2.44973 -3.17486,-2.44973 -0.24179,-9.1e-4 -0.24179,-9.2e-4 v 4.78207 4.78208 l 0.19531,0.19529 0.1953,0.19531 2.94796,-2.29308 2.94798,-2.29308 z m -65.30069,3.30019 -4.41858,-3.43828 0.87232,-0.73228 0.87233,-0.73228 3.78805,-2.91212 3.78804,-2.91212 v 7.11006 7.11006 l -0.24179,-0.0274 -0.24179,-0.0274 z m 3.8147,-8.34065 -0.13759,-0.13759 -3.08308,2.35879 -3.08307,2.35879 -0.0119,0.22234 -0.0119,0.22235 3.14327,2.4298 3.14327,2.42981 0.0893,-4.87336 0.0892,-4.87335 -0.13758,-0.13758 z m 23.3077,-25.48258 2.91211,-3.78805 0.73228,-0.87598 0.73229,-0.87598 3.38506,4.40725 3.38506,4.40726 0.10747,0.25677 0.10745,0.25677 h -7.13692 -7.13693 z m 9.13403,2.41789 -0.31859,-0.40298 -2.16247,-2.82089 -2.16245,-2.82088 -0.21812,0.009 -0.21811,0.009 -2.25671,2.95851 -2.25671,2.9585 -0.10745,0.25658 -0.10747,0.25657 h 5.06333 5.06334 z"
							/>
						</g>
					</g>
					<g>
						<svg xmlns="http://www.w3.org/2000/svg"
						     y="24%"
						     x="15%"
						     viewBox="0 0 120 75"
						     class="modIcon"
						     height="70%"
						     preserveAspectRatio="xMidYMid meet"
						     v-html="getSelectedOverclockIcon(computedState)"></svg>
					</g>
				</svg>
			</div>
			<popover name="overclocks" class="overclockGrid">
				<div v-for="(overclock, overclockId) in availableOverclocks"
				     :key="overclockId"
				     v-on:click="selectOverclock(selectedClassId, selectedEquipmentId, overclockId, overclock.selected)"
				     v-on:mouseover="hoverOverclock(selectedClassId, selectedEquipmentId, overclockId)"
				     class="tooltip-target modDisplay"
				     :class="[overclock.selected ? 'selectedTemp' : '']">
					<svg viewBox="0 0 80 80"
					     height="6rem"
					     class="mod"
					     :class="[overclock.selected ? 'overclockBackgroundActive' : 'overclockBackground']">
						<g :display="getCleanDisplayByOverclock(overclock)">
							<g> <!-- background layer -->
								<path
										style="fill:#379c5d;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"
										d="M 16.645549,6.8857899 63.523153,6.92059 79.999998,30.39618 52.538582,73.114198 26.69254,73.0896 2.5e-7,30.232339 Z"
										id="path817"/>
							</g>
							<g transform="translate(0,-217)">
								<path style="fill:#000000;stroke-width:0.32307553"
								      d="M 14.900282,271.17622 3.1080334,252.26279 1.5540136,249.74756 2.5e-7,247.23234 8.3227717,235.55906 l 8.3227773,-11.67327 23.438794,0.0174 23.438811,0.0174 8.238423,11.6389 L 80,247.19838 v 0.0989 0.0989 l -13.730705,21.35901 -13.730713,21.35901 -12.923021,-0.0123 -12.92302,-0.0123 z m 40.513633,11.25399 3.844557,-6.04021 -1.016278,-1.83457 -1.016287,-1.83457 3.937786,-6.63632 3.937787,-6.6363 2.57636,-0.0928 2.57636,-0.0928 3.822907,-5.9508 3.822909,-5.95081 v -0.24646 -0.24647 l -7.533474,-10.60265 -7.533473,-10.60266 -6.15636,-0.0876 -6.156359,-0.0876 -1.347607,2.26837 -1.347615,2.26836 h -7.69994 -7.699939 l -1.255394,-2.18076 -1.255403,-2.18076 -6.189658,-0.0877 -6.189668,-0.0876 -7.6350455,10.71246 -7.6350361,10.71247 0.1854321,0.48323 0.1854322,0.48323 3.6035723,5.77266 3.6035723,5.77266 2.6093837,0.013 2.609385,0.013 3.715374,6.33241 3.715364,6.33242 0.128735,0.34077 0.128734,0.34076 -1.060593,1.96527 -1.060593,1.9653 3.677999,5.88452 3.678009,5.88452 11.792249,-0.0128 11.792258,-0.0128 3.844558,-6.0402 z m -30.453253,-0.32014 -3.347257,-5.40143 1.08499,-2.01551 1.084991,-2.0155 -0.339123,-0.56909 -0.339122,-0.56909 -3.85954,-6.54229 -3.859539,-6.54228 h -2.591517 -2.591516 l -3.3691817,-5.41152 -3.3691721,-5.41151 -0.00183,-0.48462 -0.00183,-0.48461 7.2025468,-10.0961 7.202557,-10.09611 h 5.778086 5.778095 l 1.207809,2.09998 1.207809,2.09999 h 8.322916 8.322915 l 1.207809,-2.09999 1.207809,-2.09998 h 5.730281 5.730273 l 6.367763,8.96535 6.367765,8.96534 0.964653,1.36218 0.964654,1.36218 -3.579725,5.58394 -3.579725,5.58394 -2.578649,0.0934 -2.57864,0.0934 -4.214726,7.10173 -4.214726,7.10174 1.002092,1.85099 1.002092,1.85097 -3.550592,5.49229 -3.550585,5.49228 -11.436788,0.0707 -11.436788,0.0707 z m 28.198477,-0.0313 2.70689,-4.16064 0.402047,-0.75124 0.402057,-0.75123 -1.096548,-2.03382 -1.096548,-2.03382 -0.161539,0.0143 -0.161538,0.0143 -2.90768,4.65716 -2.90768,4.65716 -8.29643,0.0127 -8.29643,0.0127 -2.997356,-4.6846 -2.997355,-4.68459 H 25.564205 25.37739 l -1.035904,2.10069 -1.035903,2.1007 2.98578,4.83323 2.985789,4.83326 10.587544,0.0122 10.587545,0.0122 z m -36.943038,-25.84143 -0.32229,-0.60221 -2.374636,-3.84006 -2.374635,-3.84008 -0.21309,-0.35839 -0.21308,-0.35838 5.249017,-7.39544 5.249026,-7.39542 4.569719,-0.16154 4.569728,-0.16155 0.222467,-0.22336 0.222458,-0.22337 -1.1942,-1.96585 -1.1942,-1.96588 -4.702474,0.0893 -4.702465,0.0892 -5.936823,8.39996 -5.9368314,8.39996 -0.840379,1.20445 -0.840379,1.20445 3.0241336,4.85322 3.0241338,4.85322 h 2.518545 2.518554 z m 55.709708,-4.24808 3.138728,-4.8503 -0.3088,-0.39967 -0.308791,-0.39969 -6.542801,-9.29688 -6.542802,-9.29688 -4.712145,0.0892 -4.712145,0.0892 -1.059733,1.7769 -1.059723,1.77692 -0.01255,0.40384 -0.01255,0.40386 h 4.670686 4.670687 l 5.236964,7.33508 5.236965,7.33508 -0.0109,0.33796 -0.0109,0.33796 -2.789138,4.3557 -2.789147,4.35568 v 0.24815 0.24813 h 2.389664 2.389655 l 3.138728,-4.85031 z m -51.381551,22.44558 0.859245,-1.46619 -0.101618,-0.57766 -0.101627,-0.57768 -3.392296,-5.7018 -3.392287,-5.7018 -2.375103,-0.008 -2.3751025,-0.008 0.7597245,1.25046 0.759724,1.25046 4.038442,6.49148 4.038442,6.49148 0.211615,0.0119 0.211606,0.0119 0.859235,-1.46619 z m 44.909678,-6.20734 4.692263,-7.51197 v -0.17522 -0.17523 l -2.333287,0.0949 -2.333297,0.0949 -3.53202,5.95933 -3.53203,5.95931 0.903368,1.72541 0.903369,1.72542 0.269685,-0.0925 0.269687,-0.0925 z m -17.263046,-41.3532 0.968473,-1.69615 h -8.891118 -8.891108 v 0.16136 0.16137 l 0.888459,1.61573 0.888459,1.6157 7.034177,-0.081 7.034194,-0.081 z"
								      id="path838"/>
							</g>
						</g>
						<g :display="getBalancedDisplayByOverclock(overclock)">
							<g>
								<path
										style="fill:#e9ca37;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"
										d="M 0.676502,26.11698 5.2900339,23.37613 V 19.90961 L 39.830893,0 74.387947,19.8847 v 3.47593 l 4.935551,2.80812 V 53.989009 L 74.419528,56.68047 74.223427,60.412899 40.283264,79.999998 5.4545499,60.39224 5.125512,56.603608 0.84802198,54.13516 Z"
								/>
							</g>
							<g transform="translate(0,-217)">
								<path style="fill:#000000;stroke-width:0.32903767"
								      d="m 22.39999,287.18321 -16.94544,-9.79097 -0.164519,-1.89431 -0.164519,-1.89432 -2.138745,-1.23423 -2.138745,-1.23422 -0.08576,-14.00909 -0.08576,-14.00909 2.306765,-1.37043 2.306767,-1.37042 v -1.73327 -1.73325 L 22.560466,226.9548 39.830893,217 l 0.250823,0.13716 0.250832,0.13716 17.0277,9.80518 17.0277,9.8052 v 1.73796 1.73797 l 2.46778,1.40405 2.46777,1.40407 v 13.91014 13.91012 l -2.45198,1.34573 -2.45199,1.34573 -0.0981,1.86622 -0.098,1.86621 -7.07431,4.07885 -7.07432,4.07886 -9.895762,5.7147 -9.895772,5.71469 -0.468917,-0.0129 -0.468919,-0.0129 z m 35.124778,-2.01028 15.54703,-8.99489 v -2.44763 -2.44764 l 0.97011,0.21308 0.97013,0.21308 1.0041,-0.74237 1.00411,-0.74237 v -13.04966 -13.04965 l -1.27722,-0.57595 -1.27721,-0.57594 -0.69701,0.37303 -0.69701,0.37303 -0.0156,-2.89066 -0.0156,-2.89065 -15.95838,-9.21306 -15.958379,-9.21305 -0.627196,-0.29025 -0.62721,-0.29025 -16.459727,9.5033 -16.459739,9.50331 -0.0075,2.71455 -0.0075,2.71457 -0.246779,-0.0231 -0.246778,-0.0231 -0.658075,-0.26783 -0.658075,-0.26782 -1.233892,0.68057 -1.23389,0.68059 v 13.10623 13.10624 l 1.164736,0.55543 1.164736,0.55542 0.961682,-0.36299 0.961684,-0.36299 0.09458,2.78453 0.09459,2.78455 16.432691,9.51642 16.432689,9.51643 1.006315,-0.58878 1.006305,-0.58877 15.547032,-8.9949 z m -33.658043,-0.1579 -16.108912,-9.32809 -0.09439,-2.59703 -0.0944,-2.59705 3.220254,-1.32396 3.220249,-1.32396 0.08674,-10.7064 0.08665,-10.7064 -1.238316,-0.53506 -1.238323,-0.53506 -1.974227,-0.77012 -1.974226,-0.77011 -0.08889,-2.61299 -0.08889,-2.61299 9.960016,-5.74311 9.960014,-5.74312 6.170171,-3.58713 6.170152,-3.58713 0.410588,0.16544 0.410594,0.16544 15.629289,9.06129 15.62929,9.06129 0.0945,2.77654 0.0945,2.77655 -3.30701,1.41208 -3.30701,1.41209 0.0867,10.70119 0.0867,10.70118 3.2081,1.29127 3.20812,1.29127 -0.005,2.51306 -0.005,2.51306 -14.51964,8.39046 -14.519642,8.39046 -1.530447,0.89256 -1.53045,0.89257 z m 20.578789,4.63388 4.11297,-2.39803 0.09752,-2.01803 0.09751,-2.01803 4.956504,-2.80667 4.95651,-2.80669 1.39112,0.81526 1.39113,0.81525 h 0.42182 0.42181 l 3.90902,-2.31318 3.90903,-2.31316 v -1.63087 -1.63087 l -1.2147,-0.50753 -1.21468,-0.50753 -0.75954,-0.19064 -0.75954,-0.19062 -0.01,0.94052 -0.01,0.94053 -11.42425,6.49409 -11.424236,6.49409 -1.684001,0.97336 -1.684,0.97335 -13.122721,-7.46938 -13.122687,-7.46937 -0.10311,-1.06745 -0.103102,-1.06744 h -0.103503 -0.103913 l -1.86557,0.85409 -1.865572,0.85409 0.09836,1.64739 0.09836,1.6474 3.908917,2.26956 3.90892,2.26957 0.368568,-0.004 0.368577,-0.004 1.416416,-0.80979 1.416415,-0.80977 4.835302,2.74065 4.835294,2.74067 0.16452,1.99938 0.164519,1.9994 1.156694,0.76248 1.156704,0.76247 1.475605,0.7995 1.475596,0.79949 1.480669,0.9217 1.48067,0.92171 0.493559,-0.003 0.493559,-0.003 4.112969,-2.39803 z m -14.007918,-5.0167 -0.213179,-1.28727 -4.581039,-2.57024 -4.581036,-2.57024 -1.167868,0.72178 -1.167878,0.7218 0.438288,0.41821 0.438287,0.41822 5.251737,2.98957 5.251746,2.98957 0.272061,-0.27206 0.272061,-0.27207 z m 25.035812,-1.50093 5.83518,-3.3395 -1.27497,-0.77178 -1.27497,-0.77178 -0.16452,0.0187 -0.16452,0.0188 -4.44201,2.5503 -4.442004,2.5503 -0.100284,1.54221 -0.100285,1.54222 h 0.146603 0.146602 z M 13.515974,242.49085 c 0,0 17.948486,-9.49795 26.534363,-14.94305 l 26.111661,14.86916 v 1.00371 1.00371 l 0.57581,-0.23453 0.57582,-0.23453 1.39841,-0.48968 1.39842,-0.48968 v -1.70291 -1.70292 l -4.18776,-2.43342 -4.18775,-2.43342 -1.54889,0.86478 -1.54888,0.86478 -4.95709,-2.82491 -4.957084,-2.82491 v -1.8616 -1.86162 l -4.439288,-2.56876 -4.439277,-2.56876 -4.42574,2.5786 -4.425744,2.5786 -0.101252,1.94357 -0.101256,1.94357 -1.536705,0.85325 -1.536716,0.85325 -3.325384,1.89055 -3.325374,1.89054 -1.331641,-0.84062 c -0.554732,-0.33615 -0.985435,-0.72748 -1.596506,-0.94968 -2.883479,1.77657 -6.038739,3.46689 -8.563331,4.919 -0.0024,1.09831 -0.0049,2.19663 -0.0073,3.29494 1.314898,0.42789 2.703866,1.2935 3.948449,1.47617 1.1e-5,-0.62106 1e-5,-1.24212 1e-5,-1.86318 z m 12.063943,-9.19615 4.436609,-2.50428 0.162103,-0.42245 0.162114,-0.42245 -0.104183,-1.17525 -0.104182,-1.17525 -5.53,3.24767 -5.529991,3.24767 -0.0084,0.23765 -0.0084,0.23765 0.932015,0.6145 0.932024,0.61449 0.11199,0.002 0.11199,0.002 z m 34.233361,1.80449 1.13229,-0.6998 -0.27086,-0.26201 -0.27087,-0.26203 -4.84083,-2.80386 -4.840844,-2.80387 -0.689455,-0.36899 -0.689456,-0.36898 0.101171,1.54299 0.10117,1.54299 4.442004,2.57514 4.44201,2.57514 0.12569,0.0165 0.12568,0.0165 1.1323,-0.69979 z m 10.7037,33.7164 -3.70644,-1.50118 0.087,-9.91729 0.087,-9.91729 3.90041,-1.58296 3.9004,-1.58297 0.62386,0.56459 0.62387,0.56459 v 11.94022 11.94021 l -0.7313,0.51223 -0.73128,0.51221 -0.17357,-0.0156 -0.17356,-0.0156 -3.70645,-1.50118 z m 4.2,-11.43721 V 246.054 l -0.40825,-0.13609 -0.40825,-0.13608 -2.96439,1.20138 -2.96438,1.20138 v 9.14069 9.14069 l 2.6323,1.0891 2.6323,1.0891 0.74033,0.0293 0.74034,0.0293 v -11.32438 z m -70.520319,12.22924 -0.561075,-0.41131 0.08689,-12.16655 0.08689,-12.16655 0.846659,-0.29767 0.846661,-0.29767 1.127566,0.49793 1.127566,0.49793 2.545943,0.94353 2.545953,0.94353 0.0037,9.91641 0.0037,9.9164 -2.714563,1.05143 -2.714561,1.05143 -0.873362,0.46622 -0.873361,0.46623 H 5.219106 4.756947 Z m 4.630526,-2.20608 2.714561,-1.04988 -0.0032,-9.27139 -0.0032,-9.2714 -2.953685,-1.1063 -2.953685,-1.1063 -0.498047,0.19112 -0.498047,0.19112 v 10.96728 10.96728 l 0.402037,0.40204 0.402036,0.40203 0.338299,-0.13285 0.338299,-0.13286 z"
								/>
							</g>
						</g>
						<g :display="getUnstableDisplayByOverclock(overclock)">
							<g>
								<path
										style="fill:#d13500;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1"
										d="M 8.4999998e-5,40.126319 8.4302848,33.505759 V 13.11006 l 4.6897602,-4.6584702 20.295218,-0.006 6.685852,-8.4074599 6.696559,8.41266 h 20.13055 l 4.689771,4.6584701 v 20.151169 l 8.381918,7.054062 -8.37692,6.661528 -0.006,20.327659 -4.368421,4.334931 H 46.596244 L 39.857415,79.961869 33.539996,71.9618 H 13.120045 L 8.4302848,67.303329 v -20.47685 z"
								/>
							</g>
							<g transform="translate(0,-217)">
								<path style="fill:#000000;stroke-width:0.32238683"
								      d="m 36.699255,292.96222 -3.15926,-4.00042 h -10.20998 -10.20997 l -2.34488,-2.32924 -2.34488,-2.32923 V 274.0649 263.82648 l -3.94923,-3.1136 -3.94925,-3.1136 -0.26586,-0.23648 -0.26586,-0.23648 4.2151,-3.31028 4.2151,-3.31028 V 240.3079 230.11006 l 2.34488,-2.32924 2.34488,-2.32923 10.14761,-0.003 10.14761,-0.003 3.34292,-4.20373 3.34293,-4.20373 0.0812,0.0959 0.0812,0.0959 3.26708,4.11044 3.26708,4.11042 h 10.06527 10.06528 l 2.34488,2.32924 2.34489,2.32923 v 10.07559 10.07558 l 4.17345,3.31154 4.17347,3.31154 0.0175,0.21549 0.0175,0.21549 -4.18846,3.33077 -4.18846,3.33076 -0.003,10.16383 -0.003,10.16383 -2.18422,2.16747 -2.1842,2.16746 h -10.32616 -10.32617 l -3.18093,4.04514 -3.18094,4.04514 -0.18848,0.11649 -0.18848,0.11649 -3.15926,-4.00044 z m 6.2672,-2.04947 2.6995,-3.52963 10.30771,-0.0166 10.3077,-0.0166 2.02359,-2.0056 2.02359,-2.0056 0.0166,-10.3257 0.0166,-10.32569 3.52963,-2.69951 3.52961,-2.69949 -0.01,-0.20198 -0.0101,-0.20197 -3.53623,-2.69568 -3.53621,-2.69568 v -10.19111 -10.19112 l -2.0056,-2.0236 -2.00561,-2.02359 h -10.22048 -10.22055 l -2.6507,-3.46565 -2.65071,-3.46566 -0.23472,-0.26566 -0.23473,-0.26566 -2.86149,3.71997 -2.86149,3.71996 -10.15518,0.0175 -10.1552,0.0174 -2.01491,1.95925 -2.01492,1.95925 -0.0113,10.20476 -0.0113,10.20475 -3.71996,2.8615 -3.71998,2.86149 0.26568,0.23054 0.26564,0.23055 3.46567,2.67712 3.46565,2.67712 v 10.36862 10.36861 l 1.89737,1.83529 1.89737,1.8353 h 10.31735 10.31733 l 2.69568,3.53622 2.69568,3.53622 0.20197,0.01 0.20198,0.0101 2.69951,-3.52963 z m -6.59649,-2.69727 -3.49303,-4.57307 3.75301,-0.091 3.753,-0.091 3.48976,0.091 3.48974,0.091 -3.50141,4.51124 -3.5014,4.51124 -0.24832,0.0619 -0.24832,0.0619 z m 6.48009,-0.42853 2.29309,-2.94797 -0.19531,-0.1953 -0.19531,-0.1953 h -4.78206 -4.78208 l 9.1e-4,0.24179 9.2e-4,0.24179 2.44972,3.17487 2.44975,3.17485 0.2335,-0.27337 0.2335,-0.27339 2.29309,-2.94797 z m -30.32426,-2.94982 -1.84846,-1.86795 0.0855,-9.7238 0.0854,-9.7238 1.69821,1.32342 1.69822,1.32342 0.1607,-0.16069 0.16069,-0.16069 -0.0858,-8.95521 -0.0858,-8.95521 -1.68305,1.33057 -1.68305,1.33057 h -0.17068 -0.17067 v -9.60202 -9.60202 l 1.70266,-1.68151 1.70268,-1.68152 h 9.76364 9.76366 l -1.09995,1.37014 -1.09995,1.37015 -0.2302,0.40298 -0.23022,0.40298 h 9.23318 9.23316 l -1.47074,-1.85372 -1.47073,-1.85372 9.57675,-0.0855 9.57676,-0.0855 1.86675,1.86677 1.86677,1.86677 -0.0855,9.56946 -0.0855,9.56947 -1.71469,-1.30772 -1.71469,-1.3077 -0.14413,0.14414 -0.14414,0.14413 0.0857,9.1063 0.0857,9.1063 1.65809,-1.32039 1.65807,-1.32038 h 0.19564 0.19565 v 9.6011 9.60109 l -1.86802,1.84854 -1.86803,1.84853 -9.60935,-0.0854 -9.60934,-0.0855 1.50239,-1.93432 1.50241,-1.93432 -9.09448,-0.0857 -9.09448,-0.0857 -0.14657,0.14658 -0.14659,0.14658 1.5036,1.95404 1.50359,1.95403 h -9.78113 -9.78114 z m 13.55595,0.17543 -0.48086,-0.72537 -3.58832,-0.0912 -3.5883,-0.0911 v 0.22697 0.22696 l 0.53355,0.58957 0.53354,0.58956 h 3.53562 3.53562 z m 35.41597,0.16119 0.42827,-0.56417 0.0102,-0.2418 0.0102,-0.24179 h -3.43013 -3.4301 l -0.42828,0.56418 -0.42827,0.56417 -0.0102,0.24179 -0.0102,0.2418 h 3.43013 3.43011 z m -43.58667,-0.56417 -0.52809,-0.80598 h 4.22067 4.22068 l 0.52809,0.80598 0.52808,0.80596 h 1.89725 1.89724 l -0.003,-0.24179 -0.003,-0.24179 -1.47446,-1.85373 -1.47449,-1.85372 h -4.71376 -4.71374 l -1.0631,-1.0304 -1.06311,-1.0304 -0.018,-4.85316 -0.018,-4.85316 -1.73633,-1.37015 -1.73632,-1.37013 h -0.18 -0.18 v 7.5976 7.59761 l 1.51222,1.75161 1.51223,1.75161 h 1.55788 1.55788 z m 36.13697,-0.1612 0.58352,-0.64478 h 4.20553 4.20554 l -0.38685,0.38687 -0.38687,0.38687 v 0.2579 0.25791 h 1.35907 1.35907 l 1.54241,-1.51922 1.54241,-1.51921 v -7.66881 -7.6688 h -0.18842 -0.18843 l -1.90709,1.49829 -1.90709,1.4983 v 4.6923 4.69231 l -1.03041,1.0631 -1.0304,1.0631 h -4.73373 -4.73372 l -1.22486,1.53134 -1.22487,1.53134 -0.30418,0.40298 -0.30418,0.40298 h 2.08502 2.08502 z m -37.88046,-44.44693 v -4.68988 l 1.19379,-1.22254 1.19378,-1.22254 h 4.73117 4.73118 l 1.32875,-1.72231 1.32874,-1.72231 v -0.21201 -0.21201 h -1.91092 -1.91092 l -0.63398,0.80596 -0.63397,0.80597 h -4.28971 -4.2897 l -0.32744,0.0221 1.04643,-0.74114 3.87591,0.0535 3.87592,0.0535 0.34249,-0.63993 0.34248,-0.63993 v -0.1824 -0.18239 h -3.28369 -3.28369 l -0.74615,0.70097 -0.74614,0.70097 -1.42356,0.87693 1.42356,-1.63409 h -1.35907 -1.35908 l -1.54241,1.51922 -1.5424,1.51921 v 7.82967 7.82966 l 1.93431,-1.50214 1.93432,-1.50213 z m 50.37883,-9.24262 -1.53722,-1.75285 -1.5813,-0.004 -1.5813,-0.004 0.53354,0.58956 0.53354,0.58957 v 0.2164 0.21641 h -4.09831 -4.09833 l -0.65689,-0.82355 -0.65687,-0.82355 -2.01055,0.0982 -2.01057,0.0982 1.4725,1.85373 1.4725,1.85372 h 4.71374 4.71375 l 1.0631,1.0304 1.0631,1.03041 v 4.7608 4.76081 l 2.01492,1.6771 2.01491,1.67711 0.0864,-7.64572 0.0865,-7.64572 z m -5.08348,-1.43859 -0.5835,-0.64478 h -3.49902 -3.49902 l 0.40266,0.64478 0.40267,0.64476 h 3.67986 3.67988 z m 4.997,27.8972 v -7.29648 l 0.43893,0.2578 0.43891,0.25781 4.21663,3.22387 4.21661,3.22387 0.019,0.19005 0.019,0.19007 -2.01492,1.55633 -2.01492,1.55633 -2.65969,2.06841 -2.65968,2.06842 v -7.29648 z m 7.52709,0.12734 0.27338,-0.23351 -3.17487,-2.44973 -3.17486,-2.44973 -0.24179,-9.1e-4 -0.24179,-9.2e-4 v 4.78207 4.78208 l 0.19531,0.19529 0.1953,0.19531 2.94796,-2.29308 2.94798,-2.29308 z m -65.30069,3.30019 -4.41858,-3.43828 0.87232,-0.73228 0.87233,-0.73228 3.78805,-2.91212 3.78804,-2.91212 v 7.11006 7.11006 l -0.24179,-0.0274 -0.24179,-0.0274 z m 3.8147,-8.34065 -0.13759,-0.13759 -3.08308,2.35879 -3.08307,2.35879 -0.0119,0.22234 -0.0119,0.22235 3.14327,2.4298 3.14327,2.42981 0.0893,-4.87336 0.0892,-4.87335 -0.13758,-0.13758 z m 23.3077,-25.48258 2.91211,-3.78805 0.73228,-0.87598 0.73229,-0.87598 3.38506,4.40725 3.38506,4.40726 0.10747,0.25677 0.10745,0.25677 h -7.13692 -7.13693 z m 9.13403,2.41789 -0.31859,-0.40298 -2.16247,-2.82089 -2.16245,-2.82088 -0.21812,0.009 -0.21811,0.009 -2.25671,2.95851 -2.25671,2.9585 -0.10745,0.25658 -0.10747,0.25657 h 5.06333 5.06334 z"
								/>
							</g>
						</g>
						<g>
							<svg xmlns="http://www.w3.org/2000/svg"
							     y="24%"
							     x="15%"
							     viewBox="0 0 120 75"
							     :class="[overclock.selected ? 'overclockIconActive' : 'modIcon']"
							     height="70%"
							     preserveAspectRatio="xMidYMid meet"
							     v-html="getIconFromPath(overclock.icon)"></svg>
						</g>
					</svg>
				</div>
			</popover>
		</div>
		<div class="modTextBox" v-if="!!hoveredMod.name">
			<div class="modTextBoxHeader">
				<div class="modTextBoxIcon">
					<svg viewBox="0 0 80 50" height="100%" class="modPadding modBackgroundActiveNoStroke">
						<path
								d="M 0.3679663,25 13.7826,0.609756 H 66.221625 L 79.636259,25 66.221625,49.390244 H 13.7826 L 0.3679663,25"/>
						<g>
							<svg xmlns="http://www.w3.org/2000/svg"
							     y="10%"
							     viewBox="0 0 80 50"
							     class="modIconActive"
							     height="80%"
							     preserveAspectRatio="xMidYMid meet"
							     v-html="getIconFromPath(hoveredMod.icon)"></svg>
						</g>
					</svg>
				</div>
				<div class="modTextBoxTitle">
					<p class="allCaps">{{ hoveredMod.type }}</p>
					<p class="allCaps modificationName">{{ hoveredMod.name }}</p>
					<p class="costList">
						<span class="costListItem" v-if="hoveredMod.cost.credits > 0">
							<img src="../assets/img/20px-Credit.png" alt="Credits" title="Credits"/>
							<span>{{ hoveredMod.cost.credits }}</span>
						</span>
						<span class="costListItem" v-if="hoveredMod.cost.bismor > 0">
							<img src="../assets/img/Bismor_icon.png" alt="Bismor" title="Bismor"/>
							<span>{{ hoveredMod.cost.bismor }}</span>
						</span>
						<span class="costListItem" v-if="hoveredMod.cost.croppa > 0">
							<img src="../assets/img/Croppa_icon.png" alt="Croppa" title="Croppa"/>
							<span>{{ hoveredMod.cost.croppa }}</span>
						</span>
						<span class="costListItem" v-if="hoveredMod.cost.enorPearl > 0">
							<img src="../assets/img/Enor_pearl_icon.png" alt="Enor Pearl" title="Enor Pearl"/>
							<span>{{ hoveredMod.cost.enorPearl }}</span>
						</span>
						<span class="costListItem" v-if="hoveredMod.cost.jadiz > 0">
							<img src="../assets/img/Jadiz_icon.png" alt="Jadiz" title="Jadiz"/>
							<span>{{ hoveredMod.cost.jadiz }}</span>
						</span>
						<span class="costListItem" v-if="hoveredMod.cost.magnite > 0">
							<img src="../assets/img/Magnite_icon.png" alt="Magnite" title="Magnite"/>
							<span>{{ hoveredMod.cost.magnite }}</span>
						</span>
						<span class="costListItem" v-if="hoveredMod.cost.umanite > 0">
							<img src="../assets/img/Umanite_icon.png" alt="Umanite" title="Umanite"/>
							<span>{{ hoveredMod.cost.umanite }}</span>
						</span>
					</p>
				</div>
			</div>
			<div>
				{{ hoveredMod.text }}
			</div>
		</div>
	</div>
</template>

<!--todo: reset button-->
<script>
	import store from "../store";

	export default {
		name: "ModificationSelect",
		computed: {
			selectedClassId: function() {
				return store.state.selected.class;
			},
			selectedEquipmentId: function() {
				return store.state.selected.equipment;
			},
			availableMods: function() {
				return store.state.tree[this.selectedClassId][this.selectedEquipmentId].mods;
			},
			availableOverclocks: function() {
				return store.state.tree[this.selectedClassId][this.selectedEquipmentId].overclocks;
			},
			hoveredMod: function() {
				return store.state.hovered;
			},
			computedState: function() {
				return store.state;
			}
		},
		methods: {
			selectMod(classId, equipmentId, tierId, modId, selected) {
				if (selected) {
					store.commit("deSelectAllModifications", {
						classID: classId,
						equipID: equipmentId,
						tierID: tierId,
						modID: modId
					});
				} else {
					store.commit("selectModification", {
						classID: classId,
						equipID: equipmentId,
						tierID: tierId,
						modID: modId
					});
					store.commit("deSelectOtherModifications", {
						classID: classId,
						equipID: equipmentId,
						tierID: tierId,
						modID: modId
					});
				}
			},
			hoverMod(classId, equipmentId, tierId, modId) {
				store.commit("addToHovered", {
					classID: classId,
					equipID: equipmentId,
					tierID: tierId,
					modID: modId
				});
			},
			selectOverclock(classId, equipmentId, overclockId, selected) {
				let tierId = "overclock";
				if (selected) {
					store.commit("deSelectAllModifications", {
						classID: classId,
						equipID: equipmentId,
						tierID: tierId,
						modID: overclockId
					});
				} else {
					store.commit("selectModification", {
						classID: classId,
						equipID: equipmentId,
						tierID: tierId,
						modID: overclockId
					});
					store.commit("deSelectOtherModifications", {
						classID: classId,
						equipID: equipmentId,
						tierID: tierId,
						modID: overclockId
					});
				}
			},
			hoverOverclock(classId, equipmentId, overclockId) {
				let tierId = "overclock";
				store.commit("addToHovered", {
					classID: classId,
					equipID: equipmentId,
					tierID: tierId,
					modID: overclockId
				});
			},
			getSelected: function(mod) {
				return mod.selected;
			},
			getIconFromPath: function(iconPath) {
				// combine icon from path with icon border!
				return store.state.icons.mods[iconPath];
			},
			getSelectedOverclockIcon: function(state) {
				let overclocks = state.tree[state.selected.class][state.selected.equipment].overclocks;
				let dataParts = state.dataParts[state.selected.class];
				if (!state || !dataParts) {
					return "";
				}
				let dataPartsEquipment = dataParts[state.selected.equipment];
				if (!dataPartsEquipment || !overclocks) {
					return "";
				}
				let selectedOverclock = overclocks[dataPartsEquipment["overclock"]];
				return selectedOverclock ? state.icons.mods[selectedOverclock.icon] : "";
			},
			getSelectedOverclockClass: function(state) {
				let overclocks = state.tree[state.selected.class][state.selected.equipment].overclocks;
				let dataParts = state.dataParts[state.selected.class];
				if (!state || !dataParts) {
					return "clean";
				}
				let dataPartsEquipment = dataParts[state.selected.equipment];
				if (!dataPartsEquipment || !overclocks) {
					return "clean";
				}
				let selectedOverclock = overclocks[dataPartsEquipment["overclock"]];
				return selectedOverclock ? selectedOverclock.type : "clean";
			},
			getOverclocksAvailable: function(state) {
				let overclocks = state.tree[state.selected.class][state.selected.equipment].overclocks;
				return !overclocks ? "displayNone" : "";
			},
			getCleanDisplay: function(state) {
				return this.getSelectedOverclockClass(state) === "clean" ? "inherit" : "none";
			},
			getBalancedDisplay: function(state) {
				return this.getSelectedOverclockClass(state) === "balanced" ? "inherit" : "none";
			},
			getUnstableDisplay: function(state) {
				return this.getSelectedOverclockClass(state) === "unstable" ? "inherit" : "none";
			},
			getCleanDisplayByOverclock: function(overclock) {
				return overclock.type === "clean" ? "inherit" : "none";
			},
			getBalancedDisplayByOverclock: function(overclock) {
				return overclock.type === "balanced" ? "inherit" : "none";
			},
			getUnstableDisplayByOverclock: function(overclock) {
				return overclock.type === "unstable" ? "inherit" : "none";
			}
		}
	};
</script>

<style scoped>
	h2 {
		width: 11rem;
	}

	.displayNone {
		display: none !important;
	}

	.levelIndicator {
		margin: 0;
		font-size: 1rem;
		font-style: normal;
		font-weight: normal;
		color: rgba(255, 251, 255, 0.2);
	}

	.modSelection {
		flex: 1;
		height: 100%;
		width: 100%;
		padding-left: 1rem;
	}

	.modificationName {
		font-size: 1.2rem;
	}

	.modSelectionTitle {
		width: 100%;
		/*background-color: #282117;*/
		color: #fffbff;
		font-size: 1.2rem;
		text-align: center;
	}

	.tierContainer {
		display: flex;
		/*padding-top: 0.5rem;
		padding-bottom: 0.5rem;*/
		justify-content: start;
		align-items: center;
		color: #282117;
	}

	.overclockContainer {
		display: flex;
		/*padding-top: 0.5rem;
		padding-bottom: 0.5rem;*/
		justify-content: start;
		align-items: center;
		color: #282117;
	}

	.overclockGrid {
		width: auto !important;
		display: grid;
		grid-gap: 10px;
		grid-template-columns: 6rem 6rem 6rem;
		grid-template-rows: 6rem 6rem 6rem;
		justify-items: center;
		background-color: rgba(91, 64, 45, 0.75);
		border-color: rgb(255, 255, 255);
		border-style: solid;
		padding: 10px 5px 10px 5px;
	}

	.tierSubContainer {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.tierBackgroundGradient {
		background: linear-gradient(
				to bottom,
				rgba(0, 0, 0, 0) 40%,
				rgba(40, 33, 23, 1) 40%,
				rgba(40, 33, 23, 1) 60%,
				rgba(0, 0, 0, 0) 60%
		) no-repeat;
		background-size: 100% 100%;
	}

	.tierBackgroundGradientHalf {
		background: linear-gradient(
				to bottom,
				rgba(0, 0, 0, 0) 40%,
				rgba(40, 33, 23, 1) 40%,
				rgba(40, 33, 23, 1) 60%,
				rgba(0, 0, 0, 0) 60%
		) no-repeat;
		background-size: 50% 100%;
	}

	.overclockBackground {
		fill: #000000;
		stroke: #000000;
	}

	.modBackground {
		fill: #000000;
		stroke: #fc9e00;
		stroke-width: 2px;
	}

	.modBackgroundActive {
		fill: #fc9e00;
		stroke: #fffbff;
		stroke-width: 2px;
	}

	.overclockBackground {
		fill: #000000;
		stroke: none;
		stroke-width: 2px;
	}

	.overclockBackgroundActive {
		fill: #fc9e00;
		stroke: #fffbff;
		stroke-width: 2px;
	}

	.modBackgroundActiveNoStroke {
		fill: #fc9e00;
		stroke-width: 0px;
	}

	.modIcon {
		fill: #5b402d;
		stroke: none;
	}

	.modIconActive {
		fill: #000000;
		stroke: none;
	}

	.overclockIconActive {
		fill: #ada195;
		stroke: none;
	}

	.modPadding {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
	}

	.modDisplay {
		cursor: pointer;
		height: 4rem;
		width: 6rem;
	}

	.overclockDisplay {
		cursor: pointer;
		height: 6rem;
		width: 100%;
	}

	.hundredPercent {
		width: 100%;
	}

	.pseudoModDisplay {
		height: 4rem;
		width: 6rem;
	}

	.modDisplay:hover .modBackground {
		stroke: #fffbff;
	}

	.modDisplay:hover .overclockBackground {
		stroke: #fffbff;
	}

	.modTextBox {
		min-height: 11rem;
		padding-top: 1rem;
		color: #fffbff;
	}

	.modTextBoxIcon {
		height: 5rem;
	}

	.modTextBoxHeader {
		display: flex;
		padding-bottom: 1rem;
	}

	.modTextBoxTitle p {
		margin: 0;
	}

	.increaseOverBase {
		color: rgba(255, 251, 255, 0.4);
		padding-top: 1rem;
	}

	@media (max-width: 1024px) {
		.modSelection {
			flex: 0 0 100%;
			order: 1;
			padding: 0;
		}

		.tierSubContainer {
			max-width: 30rem;
		}
	}

	@media (max-width: 550px) {
		.modDisplay {
			height: 3rem;
			width: 4.8rem;
		}

		.pseudoModDisplay {
			height: 3rem;
			width: 4.8rem;
		}

		h2 {
			width: 20vw;
		}

		.modificationName {
			font-size: 1.2rem;
		}
	}

	@media (max-width: 400px) {
		.overclockGrid {
			left: 5% !important;
			width: 90% !important;
		}
	}
</style>
